<template>
  <div>
    <h1>
      Reseller Certificate Download Information
    </h1>
    <div>
      Your item has been added to your cart.
    </div>
    <div style="margin-top: 30px">
      <div class="red-help">
        Note: All links will open in a new window. You may continue shopping but
        your order cannot be processed by Gunold until you have completed,
        signed, and faxed a copy of the necessary form to us.
      </div>
      <div style="margin-top: 30px; font-size: large">
        <ul>
          <li v-for="document in data.documents" :key="document.file">
            <a :href="mediaURL(document.file)" target="_blank">{{ document.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "^/IxPlugin/api";
import {mediaURL} from '^/utils';

export default {
  name: "reseller-certificate-list",
  data() {
    return {
      data: {
        documents: [],
      },
    };
  },
  methods: {
    getResellerDocuments() {
      return api.getResellerDocuments().then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      });
    },
    mediaURL,
  },
  async created() {
    const data = await this.getResellerDocuments();
    this.$set(this.data, "documents", data);
  },
};
</script>

<style scoped>
.red-help {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/components/global/reseller-certificate-list.vue